module.exports = __webpack_public_path__ + "static/img/miaosha.deb497d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/miaosha/miaosha.png
// module id = Kl1S
// module chunks = 0